export default "__VITE_ASSET__BYwWdc5W__"